import { render, staticRenderFns } from "./StPatricksDay_drinkSection.vue?vue&type=template&id=4adfedc6&scoped=true"
import script from "./StPatricksDay_drinkSection.vue?vue&type=script&lang=ts"
export * from "./StPatricksDay_drinkSection.vue?vue&type=script&lang=ts"
import style0 from "./StPatricksDay_drinkSection.vue?vue&type=style&index=0&id=4adfedc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4adfedc6",
  null
  
)

export default component.exports